export const SET_IS_SHOW_FUTURE_DETAIL = 'SET_IS_SHOW_FUTURE_DETAIL';
export const SET_IS_SHOW_GALLERY_MODAL = 'SET_IS_SHOW_GALLERY_MODAL';
export const SET_ACTIVE_GALLERY_MODAL = 'SET_ACTIVE_GALLERY_MODAL';

